import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import qs from 'qs'
import * as Sentry from '@sentry/browser'

// const url = process.env.NODE_ENV == "development" ? "/billservicekgi" : process.env.VUE_APP_BILL_URL
const url = process.env.VUE_APP_BILL_KGI_URL

const instance = axios.create({
  baseURL: url
})
instance.defaults.paramsSerializer = params => {
  return qs.stringify(params, { arrayFormat: 'repeat' })
}
let logoutPage = ''
instance.interceptors.request.use(reqConfig => {
  const xCorrelationId = Vue.prototype.$getGuid()
  if (Vue.prototype.$getCookie('comLoginToken')) {
    const token = Vue.prototype.$getCookie('comLoginToken').split('token=').pop()
    reqConfig.headers = {
      Authorization: `Community ${token}`,
      'X-Correlation-Id': xCorrelationId
    }
    Sentry.setTag('X-Correlation-Id', xCorrelationId)
  }
  return reqConfig
}, err => {
  return Promise.reject(err)
})
instance.interceptors.response.use(
  res => res,
  err => {
    // eslint-disable-next-line eqeqeq
    if (err && err.response && (err.response.status == 401 || err.response.status == 403)) {
      // eslint-disable-next-line eqeqeq
      if (logoutPage != router.history.current.name) {
        logoutPage = router.history.current.name
        const errorText = err?.response?.data?.Messages?.length > 0 ? err.response.data.Messages.join('\n') : '權限不足'
        Vue.prototype.$alert(`${errorText}`, '警告', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false
        }).then(() => {
          // eslint-disable-next-line eqeqeq
          if (err.response.status == 401) {
            router.push({ name: 'LoginMain' })
          // eslint-disable-next-line eqeqeq
          } else if (err.response.status == 403) {
            Vue.prototype.$toMainPage()
          }
        })
      } else {
        logoutPage = ''
      }
    }
    return Promise.reject(err)
  }
)

// Swagger: https://bs-kgi-api-dev.kingnetsmart.com.tw/index.html#/
export const apiBillserviceKGI = {
  BillBulk: {
    GetBillBulkList: (requestData, config) => instance.get('/BillBulk', Object.assign({}, { params: requestData }, config)), // 取得期別列表
    GetBillBulkBasicList: (config) => instance.get('/BillBulk/Basic', config), // 取得期別列表簡單資料
    GetBillBulkBasicListByTabletId: (queryPath, config) => instance.get(`/BillBulk/Tablet/${queryPath.tabletId}`, config), // 取得戶別期別簡單列表
    PostBillBulk: (requestData, config) => instance.post('/BillBulk', requestData, config), // 新增期別
    PostBillBulkExcel: (requestData, config) => instance.post('/BillBulk/Excel', requestData, config), // 新增期別有Excel版本
    GetBillBulk: (queryPath, config) => instance.get(`/BillBulk/${queryPath.billBulkId}`, config), // 取得期別
    DeleteBillBulk: (queryPath, config) => instance.delete(`/BillBulk/${queryPath.billBulkId}`, config), // 刪除期別
    PutBillBulk: (queryPath, requestData, config) => instance.put(`/BillBulk/${queryPath.billBulkId}`, requestData, config), // 更新期別
    GetBill: (queryPath, config) => instance.get(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}`, config), // 取得繳費單
    DeleteBill: (queryPath, config) => instance.delete(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}`, config), // 刪除繳費單
    PutBill: (queryPath, requestData, config) => instance.put(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}`, requestData, config), // 更新繳費單
    PostBillPrint: (queryPath, requestData, config) => instance.post(`/BillBulk/${queryPath.billBulkId}/Bills/Print`, requestData, config), // 列印繳費單
    GetBillList: (queryPath, requestData, config) => instance.get(`/BillBulk/${queryPath.billBulkId}/Bills`, Object.assign({}, { params: requestData }, config)), // 取得繳費單列表
    PostBill: (queryPath, requestData, config) => instance.post(`/BillBulk/${queryPath.billBulkId}/Bill`, requestData, config), // 新增繳費單
    PutBillTerm: (queryPath, requestData, config) => instance.put(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}/Term`, requestData, config), // 更新繳費項目
    GetBillReceipt: (queryPath, config) => instance.get(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}/Writeoff/Receipt`, config), // 取得繳費單收據
    GetBillReceiptPrint: (queryPath, requestData, config) => instance.post(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}/Writeoffs/Print`, requestData, config), // 列印繳費單收據
    GetImportExcelTemplate: (config) => instance.get('/BillBulk/ExcelTemplate', config), // 匯出空白範本
    PostBillExport: (queryPath, requestData, config) => instance.get(`/BillBulk/${queryPath.billBulkId}/Bills/Export`, Object.assign({}, { params: requestData }, config)), // 匯出篩選繳費單
    PutBillBulkStatus: (queryPath, config) => instance.put(`/BillBulk/${queryPath.billBulkId}/${queryPath.billStatusEnum}`, config), // 更新期別狀態 Enable/Close
    PutMultiBillStatus: (queryPath, requestData, config) => instance.put(`/BillBulk/${queryPath.billBulkId}/Bills/${queryPath.billStatusEnum}`, requestData, config), // 更新複數繳費單狀態 Enable/Close
    PutBillBulkId: (queryPath, requestData, config) => instance.post(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}/Move`, requestData, config), // 更換繳費單歸屬期別
    PostWriteoffManual: (queryPath, requestData, config) => instance.post(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}/Writeoff/Manual`, requestData, config), // 手動收帳
    DeleteWriteoffManual: (queryPath, config) => instance.delete(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}/Writeoff/${queryPath.receiptId}`, config), // 刪除手動收帳
    PostNotificationAgain: (queryPath, requestData, config) => instance.post(`/BillBulk/${queryPath.billBulkId}/Bills/Notification/Again`, requestData, config), // 繳費單再通知
    MoveWriteoff: (queryPath, requestData, config) => instance.put(`/BillBulk/${queryPath.billBulkId}/Bill/${queryPath.billId}/Writeoff/${queryPath.writeoffId}/Move`, requestData, config), // 移動收據
    PutBillDate: (queryPath, requestData, config) => instance.put(`/BillBulk/${queryPath.billBulkId}/Bill/ModifyDate`, requestData, config) // 繳費單延期
  },
  Bill: {
    GetBillList: (requestData, config) => instance.get('/Bill', Object.assign({}, { params: requestData }, config)), // 取得繳費單列表
    PutMultiBillStatus: (queryPath, requestData, config) => instance.put(`/Bill/${queryPath.billStatusEnum}`, requestData, config), // 更新複數繳費單狀態 Enable/Close
    PutBillDate: (requestData, config) => instance.put('/Bill/ModifyDate', requestData, config), // 繳費單延期
    PutNotificationAgain: (requestData, config) => instance.put('/Bill/Notification/Again', requestData, config), // 繳費單再通知
    GetBillExport: (requestData, config) => instance.post('/Bill/Export', requestData, config), // 匯出篩選繳費單
    PutBillPrint: (requestData, config) => instance.put('/Bill/Print', requestData, config), // 列印繳費單
    PutBillReceiptPrint: (requestData, config) => instance.put('/Bill/Writeoffs/Print', requestData, config) // 列印複選收據
  },
  Receipt: {
    GetReiptWay: (config) => instance.get('/Receipt', config), // 取得付款方式列表
    GetEntryReport: (requestData, config) => instance.get('/Receipt/EntryReports', Object.assign({}, { params: requestData }, config)), // 取得入帳報表
    GetEntryReportExport: (requestData, config) => instance.get('/Receipt/EntryReport/Export', Object.assign({}, { params: requestData }, config)) // 匯出入帳報表
  },
  Config: {
    GetCommunitySettingForm: (config) => instance.get('/Config/CommunitySettings', config), // 取得社區的繳費服務配置表單
    PutCommunitySettingForm: (requestData, config) => instance.put('/Config/CommunitySettings', requestData, config) // 新增社區的繳費服務配置表單
  }
}
